// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NewDocumentaryTitle_container__ZK8FT {
  max-width: 95%;
  margin: 0 auto;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  color: #333;
}

.NewDocumentaryTitle_title__VbWCt {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: #ffffff;
  line-height: 1.2;
}

.NewDocumentaryTitle_header__Q\\+kgb {
  display: flex;
  gap: 30px;
  padding-top: 5rem;
}

.NewDocumentaryTitle_cover__W9-Qn {
  width: 100%;
  height: auto;
  border-radius: 8px;
  object-fit: cover;
}

.NewDocumentaryTitle_info__DqdqX {
  flex: 1 1;
}

.NewDocumentaryTitle_title__VbWCt {
  font-size: 20px;
}

.NewDocumentaryTitle_author__OGpfi {
  color: #888;
  margin-bottom: 20px;
}

.NewDocumentaryTitle_stats__u4PbE {
  display: flex;
  gap: 20px;
  margin-bottom: 30px;
  align-items: center;
  color: hsl(0, 0%, 100%);
  font-size: 0.95rem;
  font-weight: 600;
}

.NewDocumentaryTitle_stat__Zxv-5 {
  display: flex;
  align-items: center;
  gap: 8px;
}

.NewDocumentaryTitle_icon__ybfQO {
  font-size: 0.875rem;
    color: #999;
    margin: 0;
}

.NewDocumentaryTitle_episode__X-X7X {
  font-size: 1.5rem;
  font-weight: bold;
  margin: 0;
  color: white;
}

.NewDocumentaryTitle_metaData__XRrH0 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 1.5rem;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid #eaeaea;
}

.NewDocumentaryTitle_descriptionBox__do0l- {
  padding: 3rem 3rem;
}

.NewDocumentaryTitle_insideEpisodeBox__vwKOu {
  display: flex;
  align-items: center;
  background-color: #2a2a2a;
  border-radius: 12px;
  padding: 1rem;
  transition: transform 0.3s ease-in-out;
}

.NewDocumentaryTitle_insideEpisodeBox__vwKOu:hover {
  transform: scale(1.05);
}

.NewDocumentaryTitle_episodeBox__4gwJN {
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* 4 columns */
  gap: 1rem;
  margin-top: 3rem;
}

.NewDocumentaryTitle_img__AJ7QG {
  border-radius: 12px;
  flex-shrink: 0;
  overflow: hidden;
  margin-right: 1.5rem;
  position: relative;
}

.NewDocumentaryTitle_readButton__HVI0k {
  background: #e50914;
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  font-weight: 600;
  margin-right: 20px;
}

.NewDocumentaryTitle_addLibrarybutton__MYApD {
  background: #0a7e27;
  color: white;
  border: none;
  padding: 12px 13px;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  font-weight: 600;
}

.NewDocumentaryTitle_addButton__\\+ds0c {
  color: white;
}

.NewDocumentaryTitle_readButton__HVI0k:hover {
  background: #f40d17;
}

.NewDocumentaryTitle_fullDescription__0lCxW {
  font-size: 1rem;
  line-height: 1.6;
  color: #444;
  white-space: pre-line; /* Preserves line breaks in the description */
}

.NewDocumentaryTitle_similar-books-container__5GURQ {
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
}

/* Responsive adjustments - Fixed and Improved */
@media (max-width: 1290px) {

  
  .NewDocumentaryTitle_descriptionBox__do0l- {
    padding: 3rem 3rem;
  }
  
  .NewDocumentaryTitle_episodeBox__4gwJN {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 992px) {
  .NewDocumentaryTitle_header__Q\\+kgb {
    padding: 0rem 2rem;
  }
  
  .NewDocumentaryTitle_descriptionBox__do0l- {
    padding: 2rem 2rem;
  }
  
  .NewDocumentaryTitle_episodeBox__4gwJN {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .NewDocumentaryTitle_container__ZK8FT {
    padding: 1rem;
  }
  
  .NewDocumentaryTitle_header__Q\\+kgb {
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 0 1rem;
    margin-top: 4rem;
  }
  
  .NewDocumentaryTitle_stats__u4PbE {
    justify-content: center;
    flex-wrap: wrap;
    gap: 10px;
  }
  
  .NewDocumentaryTitle_readButton__HVI0k, .NewDocumentaryTitle_addLibrarybutton__MYApD {
    display: inline-block;
  }
  
  .NewDocumentaryTitle_metaData__XRrH0 {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .NewDocumentaryTitle_descriptionBox__do0l- {
    padding: 1.5rem;
  }
  
  .NewDocumentaryTitle_episodeBox__4gwJN {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.5rem;
  }
}

@media (max-width: 480px) {
   .NewDocumentaryTitle_episodeBox__4gwJN {
    grid-template-columns: repeat(1, 1fr);
  }
  
  .NewDocumentaryTitle_insideEpisodeBox__vwKOu {
    display: flex;
    align-items: center;
  }
  
  .NewDocumentaryTitle_img__AJ7QG {
    width: 120px;
    height: auto;
    max-height: 130px;
    margin-right: 10px;
  }
  
  .NewDocumentaryTitle_readButton__HVI0k, .NewDocumentaryTitle_addLibrarybutton__MYApD {
    padding: 10px 12px;
    font-size: 14px;
    display: inline-block;
  }
  .NewDocumentaryTitle_episode__X-X7X {
    font-size: 21px;
  }
  .NewDocumentaryTitle_imageTop__to6ex{
    height: 170px;
    width: 250px;
  }
  .NewDocumentaryTitle_title__VbWCt {
    font-size: 18px;
   }
  .NewDocumentaryTitle_header__Q\\+kgb {
    gap: 5px;
  }
  .NewDocumentaryTitle_author__OGpfi{
    margin-bottom: 10px;
    font-size: 14px;
  }
  .NewDocumentaryTitle_stats__u4PbE{
    margin-bottom: 10px;
  }
  .NewDocumentaryTitle_icon__ybfQO{
    font-size: 14px;
  }
  .NewDocumentaryTitle_stats__u4PbE span{
    font-size: 14px;
  }
  .NewDocumentaryTitle_container__ZK8FT{
    padding: 0.5rem;
  }
}

/* Add these styles to your existing CSS file */

.NewDocumentaryTitle_swiperContainer__o2aJt {
  padding: 0;
  margin-bottom: 2rem;
}

.NewDocumentaryTitle_mySwiper__5gf-i {
  width: 100%;
  height: 100%;
  padding-top: 3rem;
}

.NewDocumentaryTitle_swiperSlide__8rs5B {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease;
}

.NewDocumentaryTitle_swiperSlide__8rs5B:hover {
  transform: translateY(-5px);
}

.NewDocumentaryTitle_sliderImageContainer__iiOag {
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  width: 100%;
  height: 330px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.NewDocumentaryTitle_sliderImage__z5PHe {
  width: 100%;
  height: 100%;
  transition: transform 0.3s ease;
}

.NewDocumentaryTitle_sliderImageContainer__iiOag:hover .NewDocumentaryTitle_sliderImage__z5PHe {
  transform: scale(1.05);
}

/* Swiper pagination and navigation custom styles */
.swiper-pagination-bullet {
  background: #e50914;
  opacity: 0.5;
}

.swiper-pagination-bullet-active {
  opacity: 1;
}

.swiper-button-next,
.swiper-button-prev {
  color: #e50914;
}

/* Responsive styles for swiper */
@media (max-width: 768px) {
  .NewDocumentaryTitle_swiperContainer__o2aJt {
    padding: 1.5rem;
  }
}

@media (max-width: 480px) {
  .NewDocumentaryTitle_swiperContainer__o2aJt {
    padding: 1rem;
  }
  
  .NewDocumentaryTitle_mySwiper__5gf-i {
    padding-top: 1rem;
  }

  .NewDocumentaryTitle_sliderImageContainer__iiOag {
    height: 200px;
  }
}
/* Add these styles to your NewDocumentaryTitle.module.css file */

.NewDocumentaryTitle_likeButton__vq4Lk {
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: all 0.2s ease;
}

.NewDocumentaryTitle_likeButton__vq4Lk:hover {
  transform: scale(1.05);
}

.NewDocumentaryTitle_likeButton__vq4Lk:active {
  transform: scale(0.95);
}

.NewDocumentaryTitle_heartIcon__eko6h {
  margin-right: 5px;
  transition: all 0.3s ease;
}

.NewDocumentaryTitle_liked__dgcwE {
  animation: NewDocumentaryTitle_pulse__K9sdF 0.4s ease-out;
}

@keyframes NewDocumentaryTitle_pulse__K9sdF {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.3);
  }
  100% {
    transform: scale(1);
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/video-pages/css/NewDocumentaryTitle.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,cAAc;EACd;gEAC8D;EAC9D,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;IACjB,WAAW;IACX,SAAS;AACb;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qCAAqC,EAAE,cAAc;EACrD,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qBAAqB,EAAE,6CAA6C;AACtE;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA,gDAAgD;AAChD;;;EAGE;IACE,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,eAAe;IACf,SAAS;EACX;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qCAAqC;IACrC,WAAW;EACb;AACF;;AAEA;GACG;IACC,qCAAqC;EACvC;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,qBAAqB;EACvB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,YAAY;EACd;EACA;IACE,eAAe;GAChB;EACD;IACE,QAAQ;EACV;EACA;IACE,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA,+CAA+C;;AAE/C;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,mDAAmD;AACnD;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF;AACA,iEAAiE;;AAEjE;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yDAA8B;AAChC;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".container {\n  max-width: 95%;\n  margin: 0 auto;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,\n    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n  color: #333;\n}\n\n.title {\n  font-size: 20px;\n  font-weight: 700;\n  margin-bottom: 1.5rem;\n  color: #ffffff;\n  line-height: 1.2;\n}\n\n.header {\n  display: flex;\n  gap: 30px;\n  padding-top: 5rem;\n}\n\n.cover {\n  width: 100%;\n  height: auto;\n  border-radius: 8px;\n  object-fit: cover;\n}\n\n.info {\n  flex: 1;\n}\n\n.title {\n  font-size: 20px;\n}\n\n.author {\n  color: #888;\n  margin-bottom: 20px;\n}\n\n.stats {\n  display: flex;\n  gap: 20px;\n  margin-bottom: 30px;\n  align-items: center;\n  color: hsl(0, 0%, 100%);\n  font-size: 0.95rem;\n  font-weight: 600;\n}\n\n.stat {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.icon {\n  font-size: 0.875rem;\n    color: #999;\n    margin: 0;\n}\n\n.episode {\n  font-size: 1.5rem;\n  font-weight: bold;\n  margin: 0;\n  color: white;\n}\n\n.metaData {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: 1.5rem;\n  margin-bottom: 1.5rem;\n  border-bottom: 1px solid #eaeaea;\n}\n\n.descriptionBox {\n  padding: 3rem 3rem;\n}\n\n.insideEpisodeBox {\n  display: flex;\n  align-items: center;\n  background-color: #2a2a2a;\n  border-radius: 12px;\n  padding: 1rem;\n  transition: transform 0.3s ease-in-out;\n}\n\n.insideEpisodeBox:hover {\n  transform: scale(1.05);\n}\n\n.episodeBox {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr); /* 4 columns */\n  gap: 1rem;\n  margin-top: 3rem;\n}\n\n.img {\n  border-radius: 12px;\n  flex-shrink: 0;\n  overflow: hidden;\n  margin-right: 1.5rem;\n  position: relative;\n}\n\n.readButton {\n  background: #e50914;\n  color: white;\n  border: none;\n  padding: 12px 30px;\n  border-radius: 4px;\n  font-size: 16px;\n  cursor: pointer;\n  font-weight: 600;\n  margin-right: 20px;\n}\n\n.addLibrarybutton {\n  background: #0a7e27;\n  color: white;\n  border: none;\n  padding: 12px 13px;\n  border-radius: 4px;\n  font-size: 16px;\n  cursor: pointer;\n  font-weight: 600;\n}\n\n.addButton {\n  color: white;\n}\n\n.readButton:hover {\n  background: #f40d17;\n}\n\n.fullDescription {\n  font-size: 1rem;\n  line-height: 1.6;\n  color: #444;\n  white-space: pre-line; /* Preserves line breaks in the description */\n}\n\n.similar-books-container {\n  display: block !important;\n  visibility: visible !important;\n  opacity: 1 !important;\n}\n\n/* Responsive adjustments - Fixed and Improved */\n@media (max-width: 1290px) {\n\n  \n  .descriptionBox {\n    padding: 3rem 3rem;\n  }\n  \n  .episodeBox {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (max-width: 992px) {\n  .header {\n    padding: 0rem 2rem;\n  }\n  \n  .descriptionBox {\n    padding: 2rem 2rem;\n  }\n  \n  .episodeBox {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .container {\n    padding: 1rem;\n  }\n  \n  .header {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    padding: 0 1rem;\n    margin-top: 4rem;\n  }\n  \n  .stats {\n    justify-content: center;\n    flex-wrap: wrap;\n    gap: 10px;\n  }\n  \n  .readButton, .addLibrarybutton {\n    display: inline-block;\n  }\n  \n  .metaData {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .descriptionBox {\n    padding: 1.5rem;\n  }\n  \n  .episodeBox {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 0.5rem;\n  }\n}\n\n@media (max-width: 480px) {\n   .episodeBox {\n    grid-template-columns: repeat(1, 1fr);\n  }\n  \n  .insideEpisodeBox {\n    display: flex;\n    align-items: center;\n  }\n  \n  .img {\n    width: 120px;\n    height: auto;\n    max-height: 130px;\n    margin-right: 10px;\n  }\n  \n  .readButton, .addLibrarybutton {\n    padding: 10px 12px;\n    font-size: 14px;\n    display: inline-block;\n  }\n  .episode {\n    font-size: 21px;\n  }\n  .imageTop{\n    height: 170px;\n    width: 250px;\n  }\n  .title {\n    font-size: 18px;\n   }\n  .header {\n    gap: 5px;\n  }\n  .author{\n    margin-bottom: 10px;\n    font-size: 14px;\n  }\n  .stats{\n    margin-bottom: 10px;\n  }\n  .icon{\n    font-size: 14px;\n  }\n  .stats span{\n    font-size: 14px;\n  }\n  .container{\n    padding: 0.5rem;\n  }\n}\n\n/* Add these styles to your existing CSS file */\n\n.swiperContainer {\n  padding: 0;\n  margin-bottom: 2rem;\n}\n\n.mySwiper {\n  width: 100%;\n  height: 100%;\n  padding-top: 3rem;\n}\n\n.swiperSlide {\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: all 0.3s ease;\n}\n\n.swiperSlide:hover {\n  transform: translateY(-5px);\n}\n\n.sliderImageContainer {\n  position: relative;\n  overflow: hidden;\n  border-radius: 12px;\n  width: 100%;\n  height: 330px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.sliderImage {\n  width: 100%;\n  height: 100%;\n  transition: transform 0.3s ease;\n}\n\n.sliderImageContainer:hover .sliderImage {\n  transform: scale(1.05);\n}\n\n/* Swiper pagination and navigation custom styles */\n:global(.swiper-pagination-bullet) {\n  background: #e50914;\n  opacity: 0.5;\n}\n\n:global(.swiper-pagination-bullet-active) {\n  opacity: 1;\n}\n\n:global(.swiper-button-next),\n:global(.swiper-button-prev) {\n  color: #e50914;\n}\n\n/* Responsive styles for swiper */\n@media (max-width: 768px) {\n  .swiperContainer {\n    padding: 1.5rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .swiperContainer {\n    padding: 1rem;\n  }\n  \n  .mySwiper {\n    padding-top: 1rem;\n  }\n\n  .sliderImageContainer {\n    height: 200px;\n  }\n}\n/* Add these styles to your NewDocumentaryTitle.module.css file */\n\n.likeButton {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  transition: all 0.2s ease;\n}\n\n.likeButton:hover {\n  transform: scale(1.05);\n}\n\n.likeButton:active {\n  transform: scale(0.95);\n}\n\n.heartIcon {\n  margin-right: 5px;\n  transition: all 0.3s ease;\n}\n\n.liked {\n  animation: pulse 0.4s ease-out;\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.3);\n  }\n  100% {\n    transform: scale(1);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `NewDocumentaryTitle_container__ZK8FT`,
	"title": `NewDocumentaryTitle_title__VbWCt`,
	"header": `NewDocumentaryTitle_header__Q+kgb`,
	"cover": `NewDocumentaryTitle_cover__W9-Qn`,
	"info": `NewDocumentaryTitle_info__DqdqX`,
	"author": `NewDocumentaryTitle_author__OGpfi`,
	"stats": `NewDocumentaryTitle_stats__u4PbE`,
	"stat": `NewDocumentaryTitle_stat__Zxv-5`,
	"icon": `NewDocumentaryTitle_icon__ybfQO`,
	"episode": `NewDocumentaryTitle_episode__X-X7X`,
	"metaData": `NewDocumentaryTitle_metaData__XRrH0`,
	"descriptionBox": `NewDocumentaryTitle_descriptionBox__do0l-`,
	"insideEpisodeBox": `NewDocumentaryTitle_insideEpisodeBox__vwKOu`,
	"episodeBox": `NewDocumentaryTitle_episodeBox__4gwJN`,
	"img": `NewDocumentaryTitle_img__AJ7QG`,
	"readButton": `NewDocumentaryTitle_readButton__HVI0k`,
	"addLibrarybutton": `NewDocumentaryTitle_addLibrarybutton__MYApD`,
	"addButton": `NewDocumentaryTitle_addButton__+ds0c`,
	"fullDescription": `NewDocumentaryTitle_fullDescription__0lCxW`,
	"similar-books-container": `NewDocumentaryTitle_similar-books-container__5GURQ`,
	"imageTop": `NewDocumentaryTitle_imageTop__to6ex`,
	"swiperContainer": `NewDocumentaryTitle_swiperContainer__o2aJt`,
	"mySwiper": `NewDocumentaryTitle_mySwiper__5gf-i`,
	"swiperSlide": `NewDocumentaryTitle_swiperSlide__8rs5B`,
	"sliderImageContainer": `NewDocumentaryTitle_sliderImageContainer__iiOag`,
	"sliderImage": `NewDocumentaryTitle_sliderImage__z5PHe`,
	"likeButton": `NewDocumentaryTitle_likeButton__vq4Lk`,
	"heartIcon": `NewDocumentaryTitle_heartIcon__eko6h`,
	"liked": `NewDocumentaryTitle_liked__dgcwE`,
	"pulse": `NewDocumentaryTitle_pulse__K9sdF`
};
export default ___CSS_LOADER_EXPORT___;
